// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1V4Z2","select":"styles_select__2pIaf"};